import React from "react";
import { Container, Row, Col } from "reactstrap";
import siteLogo from "../assets/BAUS_Rlogo_160x120.jpg";
import appConfig from "../data/appConfig";
import "./App.css";

const Header = () => {
	const siteLink = appConfig["siteSet"]["link"];
	const appTitle = appConfig["appSet"]["title"];
	const appTitleC = appConfig["appSet"]["titleC"];

	return (
		<div className="site-header">
			<Container fluid={false}>
				<Row>
					<Col xs="12" sm="4">
						<a href={siteLink}>
							<img src={siteLogo} alt="Site Logo" />
						</a>
					</Col>
					<Col xs="12" sm="8" className="header-block">
						<h3>{appTitleC}</h3>
						<h3>{appTitle}</h3>
					</Col>
				</Row>
			</Container>
		</div>
	);
};

export default Header;
